export default "__VITE_ASSET__B8T938V9__"